var WagerTypesConstants = [
  { name: "Win", id: 0 },
  { name: "Place", id: 1 },
  { name: "Show", id: 2 },
  {
    name: "DailyDouble",
    id: 7,
  },
  { name: "Exacta", id: 8, post0: "1ST LEG", post3: "2ND LEG" },
  {
    name: "Trifecta",
    id: 9,
  },
  {
    name: "Quinella",
    id: 12,
    post0: "1ST LEG",
    post1: "2ND LEG",
  },
  {
    name: "HouseQ",
    id: 33,
    post0: "1ST LEG",
    post3: "2ND LEG",
  },
  {
    name: "Superfecta",
    id: 13,
    post0: "1ST LEG",
    post3: "2ND LEG",
    post4: "3RD LEG",
    post5: "4TH LEG",
  },
  {
    name: "Pick3",
    id: 23,
  },
  {
    name: "Pick4",
    id: 24,
  },
  {
    name: "Pick6",
    id: 25,
  },
  {
    name: "Pick5",
    id: 36,
  },
  {
    name: "Pick8",
    id: 38,
  },
  {
    name: "Pick9",
    id: 39,
  },
  {
    name: "Pick7",
    id: 37,
  },
  {
    name: "Pick10",
    id: 40,
  },
  {
    name: "Pick11",
    id: 41,
  },
  {
    name: "Pick12",
    id: 42,
  },
  { name: "Omni", id: 45 },
  {
    name: "GrandSlam",
    id: 46,
  },
  {
    name: "High5",
    id: 44,
    post0: "1ST LEG",
    post3: "2ND LEG",
    post4: "3RD LEG",
    post5: "4TH LEG",
    post6: "5TH LEG",
  },
  { name: "ExactaBox", id: 21 },
  { name: "TrifectaBox", id: 22 },
  { name: "SuperfectaBox", id: 26 },
  { name: "QuinellaBox", id: 11 },
  { name: "HouseQBox", id: 34 },
  { name: "Win Parlay", id: 27 },
  { name: "Place Parlay", id: 28 },
  { name: "Show Parlay", id: 29 },
];

export default WagerTypesConstants;
